module.exports = __webpack_public_path__ + "img/6.06753d3.jpg";